export class ReporteVisitaModel {
    agendaVisita: string;
    tipoIdAQuienVisita: string;
    numeroIdAQuienVisita: string;
    dependencia: string;
    extensionTelefonica: string;
    nombreCompletoVisitante: string;
    nombreCompletoAQuienVisita: string;
    nombreCompletoQuienAutoriza: string;
    tipoIdQuienAutoriza: string;
    numeroIdQuienAutoriza: string;
    urlFotoVisitante: string;
    tipoIdVisitante: string;
    numeroIdVisitante: string;
    fechaCreacionAgenda: Date;
    estadoAgenda: string;
    sede: string;
    idVisita: string;
    tipoVisitante: string;
    numeroVisitasDia: number;
    banderaConsultaVisitas?: boolean;
    banderaRol?: string;
    banderaBotonCrear?: boolean;
    banderaFechaDia?: boolean;
    agendaParcial: number;
    fechaFinMultiple: string;
    
    tipoVisita: string;

    constructor(agendaVisita: string, tipoIdAQuienVisita: string, numeroIdAQuienVisita: string, dependencia: string
        , extensionTelefonica: string, nombreCompletoVisitante: string, nombreCompletoAQuienVisita: string
        , nombreCompletoQuienAutoriza: string, tipoIdQuienAutoriza: string, numeroIdQuienAutoriza: string
        , urlFotoVisitante: string, tipoIdVisitante: string, numeroIdVisitante: string
        , fechaCreacionAgenda: Date, estadoAgenda: string, sede: string, idVisita: string, tipoVisitante: string
        , numeroVisitasDia: number, banderaConsultaVisitas?: boolean, banderaRol?: string, banderaBotonCrear?: boolean
        , banderaFechaDia?: boolean) {

        this.agendaVisita = agendaVisita;
        this.tipoIdAQuienVisita = tipoIdAQuienVisita;
        this.numeroIdAQuienVisita = numeroIdAQuienVisita;
        this.dependencia = dependencia;
        this.extensionTelefonica = extensionTelefonica;
        this.nombreCompletoVisitante = nombreCompletoVisitante;
        this.nombreCompletoAQuienVisita = nombreCompletoAQuienVisita;
        this.nombreCompletoQuienAutoriza = nombreCompletoQuienAutoriza;
        this.tipoIdQuienAutoriza = tipoIdQuienAutoriza;
        this.numeroIdQuienAutoriza = numeroIdQuienAutoriza;
        this.urlFotoVisitante = urlFotoVisitante;
        this.tipoIdVisitante = tipoIdVisitante;
        this.numeroIdVisitante = numeroIdVisitante;
        this.fechaCreacionAgenda = fechaCreacionAgenda;
        this.estadoAgenda = estadoAgenda;
        this.sede = sede;
        this.idVisita = idVisita;
        this.tipoVisitante = tipoVisitante;
        this.numeroVisitasDia = numeroVisitasDia;
        this.banderaConsultaVisitas = banderaConsultaVisitas;
        this.banderaRol = banderaRol;
        this.banderaBotonCrear = banderaBotonCrear;
        this.banderaFechaDia = banderaFechaDia;
    }



}